import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ActivityReasonReferenceModel } from '../../models/reference-model/reference-general-model/activity-reason-reference.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityReasonReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/activityreasonreferences";
  
  constructor(httpClient: HttpClient,
    authService: AuthService) {
    super(httpClient, authService);
  }

  public getActivityReasonReferences(): Observable<ActivityReasonReferenceModel[]> {
    return this.httpGet<ActivityReasonReferenceModel[]>(this.PATH, null)
      .pipe(
        map(response => response.body)
      );
  }
}
